import { RouteConfig } from 'vue-router';
import { requireSeeker } from '@/router/guards/authGuards';
import confirmationStoreGuard from '@/router/guards/backupCareGuards';

const backupCareRoutes: RouteConfig[] = [
  {
    path: '/backup-care/:careSessionId/new',
    name: 'BackupCare',
    component: () => import('@/apps/backup_care/BackupCare.vue'),
    redirect: (to) => `/backup-care/${to.params.careSessionId}/new/invite`,
    beforeEnter: requireSeeker,
    children: [
      {
        path: 'invite',
        name: 'InviteTabs',
        component: () => import('@/apps/backup_care/bookings/InviteTabs.vue'),
      },
      {
        path: 'confirmation',
        name: 'Confirmation',
        component: () => import('@/apps/backup_care/bookings/Confirmation.vue'),
        beforeEnter: confirmationStoreGuard,
      },
      {
        path: 'sent',
        name: 'BookingRequestSent',
        component: () => import('@/apps/backup_care/bookings/BookingRequestSent.vue'),
      },
    ],
  },
];

export default backupCareRoutes;
